import * as t from "io-ts"

// ******************************************************************
// Publish
// ******************************************************************/

export const PublishHpDevicePostBody = t.type({
    device_type: t.literal("HP"),
    device_data: t.intersection([
        t.type({
            LCTDeviceType: t.string,
            Model: t.string,
            Make: t.string,
            Attachment_UUID: t.string,
            ModelReference: t.string,
            Function: t.string,
            HeatPumpType: t.string,
            Phases: t.number,
            Voltage: t.number,
            NominalCurrent_A7_W35: t.number,
            NominalCurrent_A7_W45: t.number,
            NominalCurrent_A7_W55: t.number,
            NominalCurrent_A7_W65: t.number,
            TotalHPSysInputRatedCurrent: t.number,
            TotalHPSysInputRatedPower: t.number,
            TotalHPSysMaxDemandCurrent: t.number,
            TotalHPSysMaxDemandPower: t.number,
            Module: t.string,
            ModuleReference: t.string,
            ProductCode: t.string,
            HarmonicStandards: t.string,
            VoltageFluctuationFlickerStandards: t.string,
            BackUpHeater_Status: t.string,
            BackUpHeater_Phases: t.number,
            BackUpHeater_ModuleReference: t.string,
            BackUpHeater_Module: t.string,
            BackUpHeater_ModuleInputRatedCurrent: t.number,
            BackUpHeater_ModuleInputRatedPower: t.number,
            BoostHeater_Status: t.string,
            BoostHeater_Phases: t.number,
            BoostHeater_ModuleReference: t.string,
            BoostHeater_Module: t.string,
            BoostHeater_ModuleInputRatedCurrent: t.number,
            BoostHeater_ModuleInputRatedPower: t.number,
            WaterHeater_Status: t.string,
            WaterHeater_Phases: t.number,
            WaterHeater_ModuleReference: t.string,
            WaterHeater_Module: t.string,
            WaterHeater_ModuleInputRatedCurrent: t.number,
            WaterHeater_ModuleInputRatedPower: t.number,
            HeatPump_Status: t.string,
            HeatPump_Phases: t.number,
            HeatPump_ModuleReference: t.string,
            HeatPump_Module: t.string,
            HeatPump_ModuleInputRatedCurrent: t.number,
            HeatPump_ModuleInputRatedPower: t.number,
        }),
        t.partial({
            ManufacturerID: t.string,
            SystemReference: t.string,
        }),
    ]),
})

export type TPublishHpDevicePostBody = t.TypeOf<typeof PublishHpDevicePostBody>

// ******************************************************************
// Amend
// ******************************************************************/

// TODO - assessor fields need added
export const NewHpDeviceAmendmentResponse = t.type({
    SystemReference: t.string,
    ManufacturerID: t.string,
    Make: t.string,
    Model: t.string,
    Attachment_UUID: t.string,
    ModelReference: t.string,
    Function: t.string,
    HeatPumpType: t.string,
    Phases: t.number,
    Voltage: t.number,
    NominalCurrent_A7_W35: t.union([t.number, t.null]),
    NominalCurrent_A7_W45: t.union([t.number, t.null]),
    NominalCurrent_A7_W55: t.union([t.number, t.null]),
    NominalCurrent_A7_W65: t.union([t.number, t.null]),
    TotalHPSysInputRatedCurrent: t.number,
    TotalHPSysInputRatedPower: t.number,
    TotalHPSysMaxDemandCurrent: t.number,
    TotalHPSysMaxDemandPower: t.number,
    Module: t.string,
    ModuleReference: t.string,
    ProductCode: t.union([t.string, t.null]),
    HarmonicStandards: t.union([t.string, t.null]),
    VoltageFluctuationFlickerStandards: t.union([t.string, t.null]),
    BackUpHeater_Status: t.string,
    BackUpHeater_Phases: t.union([t.number, t.null]),
    BackUpHeater_ModuleReference: t.union([t.string, t.null]),
    BackUpHeater_Module: t.union([t.string, t.null]),
    BackUpHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    BackUpHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    BoostHeater_Status: t.string,
    BoostHeater_Phases: t.union([t.number, t.null]),
    BoostHeater_ModuleReference: t.union([t.string, t.null]),
    BoostHeater_Module: t.union([t.string, t.null]),
    BoostHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    BoostHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    WaterHeater_Status: t.string,
    WaterHeater_Phases: t.union([t.number, t.null]),
    WaterHeater_ModuleReference: t.union([t.string, t.null]),
    WaterHeater_Module: t.union([t.string, t.null]),
    WaterHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    WaterHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    HeatPump_Status: t.string,
    HeatPump_Phases: t.union([t.number, t.null]),
    HeatPump_ModuleReference: t.union([t.string, t.null]),
    HeatPump_Module: t.union([t.string, t.null]),
    HeatPump_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    HeatPump_ModuleInputRatedPower: t.union([t.number, t.null]),
})

export const AmendHpDevicePostBody = t.type({
    device_type: t.literal("HP"),
    device_data: t.intersection([
        t.type({
            LCTDeviceType: t.string,
            Model: t.string,
            Make: t.string,
            Attachment_UUID: t.string,
            ModelReference: t.string,
            Function: t.string,
            HeatPumpType: t.string,
            Phases: t.number,
            Voltage: t.number,
            TotalHPSysInputRatedCurrent: t.number,
            TotalHPSysInputRatedPower: t.number,
            TotalHPSysMaxDemandCurrent: t.number,
            TotalHPSysMaxDemandPower: t.number,
            Module: t.string,
            ModuleReference: t.string,
            BackUpHeater_Status: t.string,
            BoostHeater_Status: t.string,
            WaterHeater_Status: t.string,
            HeatPump_Status: t.string,
        }),
        t.partial({
            ManufacturerID: t.string,
            SystemReference: t.string,
            NominalCurrent_A7_W35: t.number,
            NominalCurrent_A7_W45: t.number,
            NominalCurrent_A7_W55: t.number,
            NominalCurrent_A7_W65: t.number,
            ProductCode: t.string,
            HarmonicStandards: t.string,
            VoltageFluctuationFlickerStandards: t.string,
            BackUpHeater_Phases: t.number,
            BackUpHeater_ModuleReference: t.string,
            BackUpHeater_Module: t.string,
            BackUpHeater_ModuleInputRatedCurrent: t.number,
            BackUpHeater_ModuleInputRatedPower: t.number,
            BoostHeater_Phases: t.number,
            BoostHeater_ModuleReference: t.string,
            BoostHeater_Module: t.string,
            BoostHeater_ModuleInputRatedCurrent: t.number,
            BoostHeater_ModuleInputRatedPower: t.number,
            WaterHeater_Phases: t.number,
            WaterHeater_ModuleReference: t.string,
            WaterHeater_Module: t.string,
            WaterHeater_ModuleInputRatedCurrent: t.number,
            WaterHeater_ModuleInputRatedPower: t.number,
            HeatPump_Phases: t.number,
            HeatPump_ModuleReference: t.string,
            HeatPump_Module: t.string,
            HeatPump_ModuleInputRatedCurrent: t.number,
            HeatPump_ModuleInputRatedPower: t.number,
        }),
    ]),
})

export type TAmendHpDevicePostBody = t.TypeOf<typeof AmendHpDevicePostBody>

export type TNewHpDeviceAmendmentResponse = t.TypeOf<
    typeof NewHpDeviceAmendmentResponse
>

// ******************************************************************
// Version
// ******************************************************************/

// TODO - assessor fields need added
export const NewHpDeviceVersionResponse = t.type({
    SystemReference: t.string,
    ManufacturerID: t.string,
    Make: t.string,
    Model: t.string,
    Attachment_UUID: t.string,
    ModelReference: t.string,
    Function: t.string,
    HeatPumpType: t.string,
    Phases: t.number,
    Voltage: t.number,
    NominalCurrent_A7_W35: t.union([t.number, t.null]),
    NominalCurrent_A7_W45: t.union([t.number, t.null]),
    NominalCurrent_A7_W55: t.union([t.number, t.null]),
    NominalCurrent_A7_W65: t.union([t.number, t.null]),
    TotalHPSysInputRatedCurrent: t.number,
    TotalHPSysInputRatedPower: t.number,
    TotalHPSysMaxDemandCurrent: t.number,
    TotalHPSysMaxDemandPower: t.number,
    Module: t.string,
    ModuleReference: t.string,
    ProductCode: t.union([t.string, t.null]),
    HarmonicStandards: t.union([t.string, t.null]),
    VoltageFluctuationFlickerStandards: t.union([t.string, t.null]),
    BackUpHeater_Status: t.string,
    BackUpHeater_Phases: t.union([t.number, t.null]),
    BackUpHeater_ModuleReference: t.union([t.string, t.null]),
    BackUpHeater_Module: t.union([t.string, t.null]),
    BackUpHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    BackUpHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    BoostHeater_Status: t.string,
    BoostHeater_Phases: t.union([t.number, t.null]),
    BoostHeater_ModuleReference: t.union([t.string, t.null]),
    BoostHeater_Module: t.union([t.string, t.null]),
    BoostHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    BoostHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    WaterHeater_Status: t.string,
    WaterHeater_Phases: t.union([t.number, t.null]),
    WaterHeater_ModuleReference: t.union([t.string, t.null]),
    WaterHeater_Module: t.union([t.string, t.null]),
    WaterHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    WaterHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    HeatPump_Status: t.string,
    HeatPump_Phases: t.union([t.number, t.null]),
    HeatPump_ModuleReference: t.union([t.string, t.null]),
    HeatPump_Module: t.union([t.string, t.null]),
    HeatPump_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    HeatPump_ModuleInputRatedPower: t.union([t.number, t.null]),
})

export type TNewHpDeviceVersionResponse = t.TypeOf<
    typeof NewHpDeviceVersionResponse
>

// ******************************************************************
// Drafts
// ******************************************************************/

// TODO - assessor fields need added
export const ContinueHpDraftResponse = t.type({
    SystemReference: t.union([t.string, t.null]),
    ManufacturerID: t.union([t.string, t.null]),
    Make: t.union([t.string, t.null]),
    Model: t.union([t.string, t.null]),
    Attachment_UUID: t.union([t.string, t.null]),
    ModelReference: t.union([t.string, t.null]),
    Function: t.union([t.string, t.null]),
    HeatPumpType: t.union([t.string, t.null]),
    Phases: t.union([t.number, t.null]),
    Voltage: t.union([t.number, t.null]),
    NominalCurrent_A7_W35: t.union([t.number, t.null]),
    NominalCurrent_A7_W45: t.union([t.number, t.null]),
    NominalCurrent_A7_W55: t.union([t.number, t.null]),
    NominalCurrent_A7_W65: t.union([t.number, t.null]),
    TotalHPSysInputRatedCurrent: t.union([t.number, t.null]),
    TotalHPSysInputRatedPower: t.union([t.number, t.null]),
    TotalHPSysMaxDemandCurrent: t.union([t.number, t.null]),
    TotalHPSysMaxDemandPower: t.union([t.number, t.null]),
    Module: t.union([t.string, t.null]),
    ModuleReference: t.union([t.string, t.null]),
    ProductCode: t.union([t.string, t.null]),
    HarmonicStandards: t.union([t.string, t.null]),
    VoltageFluctuationFlickerStandards: t.union([t.string, t.null]),
    BackUpHeater_Status: t.union([t.string, t.null]),
    BackUpHeater_Phases: t.union([t.number, t.null]),
    BackUpHeater_ModuleReference: t.union([t.string, t.null]),
    BackUpHeater_Module: t.union([t.string, t.null]),
    BackUpHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    BackUpHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    BoostHeater_Status: t.union([t.string, t.null]),
    BoostHeater_Phases: t.union([t.number, t.null]),
    BoostHeater_ModuleReference: t.union([t.string, t.null]),
    BoostHeater_Module: t.union([t.string, t.null]),
    BoostHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    BoostHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    WaterHeater_Status: t.union([t.string, t.null]),
    WaterHeater_Phases: t.union([t.number, t.null]),
    WaterHeater_ModuleReference: t.union([t.string, t.null]),
    WaterHeater_Module: t.union([t.string, t.null]),
    WaterHeater_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    WaterHeater_ModuleInputRatedPower: t.union([t.number, t.null]),
    HeatPump_Status: t.union([t.string, t.null]),
    HeatPump_Phases: t.union([t.number, t.null]),
    HeatPump_ModuleReference: t.union([t.string, t.null]),
    HeatPump_Module: t.union([t.string, t.null]),
    HeatPump_ModuleInputRatedCurrent: t.union([t.number, t.null]),
    HeatPump_ModuleInputRatedPower: t.union([t.number, t.null]),
})

// TODO - assessor fields
export const SaveHpDeviceDraftPostBody = t.type({
    device_type: t.literal("HP"),
    device_data: t.partial({
        LCTDeviceType: t.string,
        SystemReference: t.string,
        ManufacturerID: t.string,
        Make: t.string,
        Model: t.string,
        Attachment_UUID: t.string,
        ModelReference: t.string,
        Function: t.string,
        HeatPumpType: t.string,
        Phases: t.number,
        Voltage: t.number,
        NominalCurrent_A7_W35: t.number,
        NominalCurrent_A7_W45: t.number,
        NominalCurrent_A7_W55: t.number,
        NominalCurrent_A7_W65: t.number,
        TotalHPSysInputRatedCurrent: t.number,
        TotalHPSysInputRatedPower: t.number,
        TotalHPSysMaxDemandCurrent: t.number,
        TotalHPSysMaxDemandPower: t.number,
        Module: t.string,
        ModuleReference: t.string,
        ProductCode: t.string,
        HarmonicStandards: t.string,
        VoltageFluctuationFlickerStandards: t.string,
        BackUpHeater_Status: t.string,
        BackUpHeater_Phases: t.number,
        BackUpHeater_ModuleReference: t.string,
        BackUpHeater_Module: t.string,
        BackUpHeater_ModuleInputRatedCurrent: t.number,
        BackUpHeater_ModuleInputRatedPower: t.number,
        BoostHeater_Status: t.string,
        BoostHeater_Phases: t.number,
        BoostHeater_ModuleReference: t.string,
        BoostHeater_Module: t.string,
        BoostHeater_ModuleInputRatedCurrent: t.number,
        BoostHeater_ModuleInputRatedPower: t.number,
        WaterHeater_Status: t.string,
        WaterHeater_Phases: t.number,
        WaterHeater_ModuleReference: t.string,
        WaterHeater_Module: t.string,
        WaterHeater_ModuleInputRatedCurrent: t.number,
        WaterHeater_ModuleInputRatedPower: t.number,
        HeatPump_Status: t.string,
        HeatPump_Phases: t.number,
        HeatPump_ModuleReference: t.string,
        HeatPump_Module: t.string,
        HeatPump_ModuleInputRatedCurrent: t.number,
        HeatPump_ModuleInputRatedPower: t.number,
    }),
    is_amendment: t.boolean,
})

export type TSaveHpDeviceDraftPostBody = t.TypeOf<
    typeof SaveHpDeviceDraftPostBody
>

export type TContinueHpDraftResponse = t.TypeOf<typeof ContinueHpDraftResponse>

// ******************************************************************
// Other
// ******************************************************************/

export type THPDeviceResponseType =
    | TNewHpDeviceAmendmentResponse
    | TContinueHpDraftResponse
